import { initI18n } from '@betstarters/i18n'

import enTranslation from './locales/en/translation.json'
import itTranslation from './locales/it/translation.json'
import esTranslation from './locales/es/translation.json'
import ptTranslation from './locales/pt/translation.json'

export default initI18n({
  defaultNS: 'translation',
  appResources: {
    en: { translation: enTranslation },
    it: { translation: itTranslation },
    es: { translation: esTranslation },
    pt: { translation: ptTranslation },
  },
})
